function ToggleSwitch({ checked, onChange, disabled = false, id }) {
    return (
        <button
            id={id}
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            onClick={() => onChange(!checked)}
            className={
                "relative inline-flex h-7 w-12 items-center rounded-full transition " +
                (disabled ? "opacity-50 cursor-not-allowed " : "cursor-pointer ") +
                (checked ? "bg-primary-500" : "bg-gray-300")
            }
        >
            <span
                className={
                    "inline-block h-5 w-5 transform rounded-full bg-white transition " +
                    (checked ? "translate-x-6" : "translate-x-1")
                }
            />
        </button>
    );
}

export default ToggleSwitch;

